import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/404',
      name: '404',
      component: require('@/pages/common/404')
    },
    {
      path: '*',
      redirect: '404'
    },
    {
      path: '/',
      name: 'Index',
      component: require('@/pages/common/index')
    },
    {
      path: '/transportloesninger',
      name: 'Products',
      component: require('@/pages/common/products'),
      children: [
        {
          path: 'stykgods',
          name: 'ProductsStykgods',
          component: require('../pages/common/products/stykgods')
        },
        {
          path: 'hellast',
          name: 'ProductsHellast',
          component: require('../pages/common/products/hellast')
        },
        {
          path: 'bulk',
          name: 'ProductsBulk',
          component: require('../pages/common/products/bulk')
        },
        {
          path: 'koel-frys',
          name: 'ProductsKoel',
          component: require('../pages/common/products/koel')
        },
        {
          path: 'farligt-gods',
          name: 'ProductsFarligt',
          component: require('../pages/common/products/farligtgods')
        },
        {
          path: 'fragtfirma',
          name: 'ProductsFragtfirma',
          component: require('@/pages/common/freightCompany')
        }
      ]
    },
    {
      path: '/hvem-er-vi',
      name: 'About',
      component: require('@/pages/common/about')
    },
    {
      path: '/hvem-er-vi-ny',
      name: 'AboutNew',
      component: require('@/pages/common/aboutNew')
    },
    {
      path: '/kontakt',
      name: 'Contact',
      component: require('@/pages/common/contact')
    },
    {
      path: '/miljo-og-sikkerhed',
      name: 'Environment',
      component: require('@/pages/common/environment')
    },
    {
      path: '/bliv-ringet-op-tak',
      name: 'ContactSuccess',
      component: require('@/pages/common/contactSuccess')
    },
    {
      path: '/privatlivspolitik',
      name: 'Privacy',
      component: require('@/pages/common/privacy')
    },
    {
      path: '/covid-19',
      name: 'Covid',
      component: require('@/pages/common/covid')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js